export default "__VITE_ASSET__VFR2iSd8__"